import { jsx as _jsx } from "react/jsx-runtime";
// tslint:disable-next-line: import-name
import React from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { logger } from '@springtree/eva-sdk-core-logger';
import evaEndpointUrlState, { storageKey } from './state/core/eva-endpoint-url-state.js';
import storage from './helpers/storage.js';
import currentUserTokenState from './state/current-user/current-user-token-state.js';
import applicationTokenState from './state/core/application-token-state.js';
import requestedOrganizationUnitIdState from './state/core/requested-organization-unit-id-state.js';
import requestedOrganizationUnitQueryState from './state/core/requested-organization-unit-query-state.js';
export default function EvaStateEndpointMonitor() {
    const [endpointUrl] = useRecoilState(evaEndpointUrlState);
    const setCurrentUserToken = useSetRecoilState(currentUserTokenState);
    const setApplicationToken = useSetRecoilState(applicationTokenState);
    const setRequestedOrganizationUnitId = useSetRecoilState(requestedOrganizationUnitIdState);
    const setRequestedOrganizationUnitQuery = useSetRecoilState(requestedOrganizationUnitQueryState);
    // Listen for endpoint changes so we can unset all the corresponding recoil state
    //
    React.useEffect(() => {
        const storedEndpointUrl = storage.getItem(storageKey);
        if (storedEndpointUrl !== endpointUrl) {
            logger.debug(`[STATE:endpointMonitor] EVA Endpoint has changed to ${endpointUrl}`)();
            storage.setItem(storageKey, endpointUrl);
            setApplicationToken('');
            setCurrentUserToken('');
            setRequestedOrganizationUnitId(undefined);
            setRequestedOrganizationUnitQuery(undefined);
        }
    }, [endpointUrl]);
    return (_jsx("div", {}));
}
//# sourceMappingURL=eva-state-endpoint-monitor.js.map